var map = {
	"./ALLERGEN_1.png": 9060,
	"./ALLERGEN_10.png": 64,
	"./ALLERGEN_11.png": 4530,
	"./ALLERGEN_12.png": 4274,
	"./ALLERGEN_13.png": 8659,
	"./ALLERGEN_14.png": 3775,
	"./ALLERGEN_2.png": 4029,
	"./ALLERGEN_3.png": 3251,
	"./ALLERGEN_4.png": 4121,
	"./ALLERGEN_5.png": 632,
	"./ALLERGEN_6.png": 9834,
	"./ALLERGEN_7.png": 8367,
	"./ALLERGEN_8.png": 1270,
	"./ALLERGEN_9.png": 3461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7772;